import { Pipe, PipeTransform } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';

@Pipe({
  name: 'filterGroupsWithStudiesPipe',
  pure: false,
})
export class FilterGroupsWithStudiesPipe implements PipeTransform {
  transform(mediaGroups: MediaGroup[], studyFiles: StudyFile[]): any {
    return mediaGroups.map((mediaGroup) => {
      const mediaCategories = mediaGroup.mediaCategories;
      return {
        ...mediaGroup,
        mediaCategories: mediaCategories.map((mediaCategory) => {
          return {
            mediaCategory,
            studyFiles: studyFiles.filter(
              (studyFile) => studyFile.mediaCategoryId === mediaCategory.id
            ),
          };
        }),
      };
    });
  }
}
